import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {ParsedAppointment} from 'presentation/pages/private/home/services/getHome/types';
import {ParsedHealthAppointment} from 'presentation/pages/private/home/utils/parseHealthAppointments/types';

interface UseHealthSpecialtiesSelectionProps {
	handleNextStep: () => void;
}

type CheckBookingModal = CheckBookingModalEnum | `${CheckBookingModalEnum}`;

enum CheckBookingModalEnum {
	VERIFYING_DUPLICITY = 'verifyingDuplicity',
	VERIFYING_AUTH = 'verifyingAuth',
	VERIFYING_DISTRICTS = 'verifyingDistricts',
	VERIFYING_REQUEST_SCHEDULE = 'verifyingRequestSchedule',
	ERROR = 'error',
	DUPLICITY_STATE = 'duplicityState',
	NEED_AUTH = 'needAuth',
	SCRIPT_STATE = 'scriptState',
	NONE = 'none',
}

type ScheduledBooking = {
	providerName: string;
	specialtyName: string;
	clinicName: string;
	bookingType: BookingTypeEnum;
	date: string;
	hour: string;
	bookingNumber: string;
	specialtyCode: string;
	subSpecialtyCode?: string;
	formattedDateWithWeekday?: string;
	specialtyNameSelected?: string | null;
};

type HealthAppointmentWithSpecialtyNameSelected = ParsedHealthAppointment & {
	specialtyNameSelected?: string;
};

interface GetHealthBookingBySpecialtyParams {
	specialtyCode: string;
	appointments?: ParsedAppointment[];
}

export type {
	CheckBookingModal,
	HealthAppointmentWithSpecialtyNameSelected,
	ScheduledBooking,
	UseHealthSpecialtiesSelectionProps,
	GetHealthBookingBySpecialtyParams,
};

export {CheckBookingModalEnum};
